import { Component, OnInit } from '@angular/core';

import { ToastService } from '../../services/toast.service';
import { Toast } from '../../models/toast';

@Component({
  selector: 'app-toasts',
  templateUrl: './toasts.component.html',
  styleUrls: ['./toasts.component.scss'],
})
export class ToastsComponent implements OnInit {
  public toasts: Toast[] = [];

  constructor(public toastService: ToastService) {}

  ngOnInit() {
    this.listenToToasts();
  }

  public getColor(toast: Toast) {
    return {
      'bg-danger': toast.type === 'error',
      'bg-success': toast.type === 'success',
      'bg-info': toast.type === 'info',
    };
  }

  private listenToToasts() {
    this.toastService.toasts$.subscribe(toast => {
      this.toasts.push(toast);

      setTimeout(() => {
        this.removeToast(toast.id);
      }, toast.timeout);
    });
  }

  private removeToast(id: number) {
    this.toasts = this.toasts.filter(toast => toast.id !== id);
  }
}
